import {SmartComponent} from "smart-component-js";

class ScreensetComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "ScreensetComponent";
        super(element, parentComponent, params);
        const wrapper = document.querySelector('div[data-window]');
        this.window = wrapper?.dataset.window || "gigya-login-screen";

        if (this.window === "gigya-reset-password-screen") this.resetPasswordScreenset();
        this.init();
    }

    init() {
        const buttons = document.querySelectorAll('.gigya-login-button');
        buttons.forEach((button) => button.addEventListener('click', (e) => {
            e.preventDefault();
            this.createLoginScreenset();
        }));
        this.redirectLogin();
    }

    redirectLogin() {
        const urlParams = new URLSearchParams(window.location.search);
        const param = urlParams.get("login");
        if (param) this.createScreenset("gigya-login-screen");
    }


    resetPasswordScreenset() {
        gigya.accounts.getAccountInfo({
            callback: function (response) {
                if (typeof response.UID !== 'undefined') {
                    location.href = 'https://my.donnad.it/utente/cambio-password';
                    return;
                }

                gigya.accounts.showScreenSet({
                    screenSet: 'Restyle2017-RegistrationLogin',
                    startScreen: 'gigya-reset-password-screen',
                    containerID: "reset-password-container"
                });
            }
        });
    }


    createLoginScreenset() {
        gigya.accounts.showScreenSet({
            containerID: "",
            mobileScreenSet: "",
            screenSet: "Restyle2021-RegistrationLogin",
            startScreen: "gigya-login-screen"
        });


        gigya.socialize.addEventHandlers({
            onLogin: (eventObj) => {
                // gigya.accounts.getAccountInfo({
                //     callback: (d) => gigya.accounts.setAccountInfo({data: {loginChannel: {channel_loyalty: true}}})
                // });
            }
        });
    }
}

export default ScreensetComponent;
